import React from "react";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const sortsValues = {
  'elastic_search_score': { 'sort_by': '_score', 'ascending': false },
  'badge': { 'sort_by': 'reviewer_type', 'ascending': false },
  'score': { 'sort_by': 'score', 'ascending': false },
  'low_score': { 'sort_by': 'score', 'ascending': true },
  'date_asc': { 'sort_by': 'date', 'ascending': true },
  'date': { 'sort_by': 'date', 'ascending': false },
  'votes': { 'sort_by': 'votes_up', 'ascending': false },
  'low_votes': { 'sort_by': 'votes_down', 'ascending': false },
  'images': { 'sort_by': 'image_count', 'ascending': false },
  'grouping': { 'sort_by': 'grouping_originated', 'ascending': true },
}


const YotpoFilters = ({loading, sort, onSortChange, search, onSearchChange, searchOptions}) => {

  const searchSelectOptions = searchOptions ? searchOptions.map((value)=>({
    value: value,
    label: value
  })) : [];

  const sortOptions = [
      { value: 'date', label: 'Newest' },
      { value: 'date_asc', label: 'Oldest' },
      { value: 'images', label: 'With Images' },
      { value: 'score', label: 'Highest Rating' },
      { value: 'low_score', label: 'Lowest Rating' },
      { value: 'votes', label: 'Most Helpful' }
  ]

  const handleSortChange = (selected) => {
    onSortChange(sortsValues[selected.value]);
  }

  const handleSearchChange = (selected) => {
    onSearchChange(selected.value);
  }

  const searchComponents = {
    DropdownIndicator: null,
  };

  const sortValue = Object.keys(sortsValues).filter((value)=> {
    return sortsValues[value].sort_by == sort.sort_by
            && sortsValues[value].ascending == sort.ascending;
  })[0];

  const sortValueObject = sortOptions.filter(({value}) => {
    return sortValue == value
  })[0]

  return(<>
    <div className="ft_yotpo__filter">
      <div className={`input-wrapper`}>
        Sort:
        <Select
            className="react-select"
            classNamePrefix="react-select"
            options={sortOptions}
            isClearable={true}
            isSearchable={true}
            openMenuOnFocus={true}
            isDisabled={loading}
            placeholder={"Sort By:"}
            onChange={handleSortChange}
            value={sortValueObject}
          />
      </div>
    </div>
    <div className="ft_yotpo__filter">
      <div className={`input-wrapper`}>
        Search:
        <CreatableSelect
            className="react-select"
            classNamePrefix="react-select"
            components={searchComponents}
            options={searchSelectOptions}
            isSearchable={true}
            openMenuOnFocus={true}
            isDisabled={loading}
            placeholder={"Search:"}
            onChange={handleSearchChange}
            value={{value:search, label:search}}
            formatCreateLabel={(value)=>`Search ${value}`}
          />
      </div>
    </div>
    </>);
}

export default YotpoFilters;

function mapSortValues(value){
  return sorts
}
